import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IFilter,
  IQueryParam,
  ICliente,
  IConfigMarker,
  IPopulate,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { ConfigMarkersService } from '../../../../../auxiliares/servicios/http/config-markers.service';
import { CrearEditarMarkerComponent } from '../crear-editar-marker/crear-editar-marker.component';
import { LoginService } from '../../../../login/login.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';

@Component({
  selector: 'app-listado-markers',
  templateUrl: './listado-markers.component.html',
  styleUrls: ['./listado-markers.component.scss'],
  standalone: false,
})
export class ListadoMarkersComponent implements OnInit, OnDestroy {
  private formularios = inject(FormularioDialogService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ConfigMarkersService);

  public clientePropio?: ICliente = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoMarkersComponent';
  public datos?: IConfigMarker[];
  public totalCount = 0;
  public columnas?: IColumnas<IConfigMarker>[];
  //Subs
  public codigosEventos$?: Subscription;

  //
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso(
      'Configuraciones - Crear iconos vehículos',
    ), // TODO-PERMISO: no hay AccionRol equivalente
    tooltip: 'Crear configuración de marker',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  public search: IRegExpSearch = {
    fields: ['scope', 'idRef'],
  };
  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestroCliente: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public global: IFiltroTabla = {
    elementos: [
      { label: 'Global', value: true },
      { label: 'No global', value: false },
    ],
    filter: {
      field: 'global',
    },
    selectLabel: 'label',
    selectValue: 'value',
    label: 'Global',
    tipo: 'select',
  };
  public scope: IFiltroTabla = {
    elementos: [
      { label: 'Cliente', value: 'cliente' },
      { label: 'Grupo', value: 'grupo' },
      { label: 'Activo', value: 'activo' },
    ],
    filter: {
      field: 'scope',
    },
    selectLabel: 'label',
    selectValue: 'value',
    label: 'Alcance',
    tipo: 'select',
  };
  public filtros: IFiltroTabla[] = [this.global, this.scope];
  //Query

  public filter: Partial<IFilter<IConfigMarker>> = {};
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'ancestros',
      select: 'nombre',
    },
    {
      path: 'idRef',
      select: 'nombre identificacion',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'scope',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: false,
    childrenLevel: 0,
  };
  // Listars

  public async listar(): Promise<void> {
    this.codigosEventos$?.unsubscribe();
    try {
      const data = await this.service.getFiltered(this.query);
      this.totalCount = data.totalCount;
      this.datos = data.datos;
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Acciones
  public crear() {
    const res = this.formularios.abrir(CrearEditarMarkerComponent, {
      tamano: 'mediano',
    });
    if (res) {
      res.afterClosed().subscribe(async () => {
        await this.listar();
      });
    }
  }

  public async editar(marker: IConfigMarker) {
    const res = this.formularios.abrir(CrearEditarMarkerComponent, {
      tamano: 'mediano',
      data: marker,
    });
    if (res) {
      res.afterClosed().subscribe(async () => {
        await this.listar();
      });
    }
  }

  public async eliminar(marker: IConfigMarker) {
    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Querés eliminar la configuración de marker de ${[
        this.alcance(marker).toLowerCase(),
        this.referencia(marker),
      ]
        .filter(Boolean)
        .join(' ')}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(marker._id!);
      this.helper.notifSuccess('Eliminación correcta');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private static ALCANCES: Record<string, string> = {
    cliente: 'Cliente',
    grupo: 'Grupo',
    activo: 'Activo',
  };

  /** Alcance con mayúscula inicial ('cliente' → 'Cliente'). */
  private alcance(dato: IConfigMarker): string {
    const scope = dato.scope as string;
    return ListadoMarkersComponent.ALCANCES[scope] ?? scope;
  }

  /** Nombre de la entidad a la que aplica (populada en idRef). */
  private referencia(dato: IConfigMarker): string | undefined {
    if (!dato.idRef || typeof dato.idRef === 'string') return undefined;
    const ref: any = dato.idRef;
    if (dato.scope === 'activo') {
      return ref.identificacion || ref.nombre || undefined;
    }
    if (dato.scope === 'cliente' || dato.scope === 'grupo') {
      return ref.nombre || undefined;
    }
    return undefined;
  }

  private setColumnas() {
    const columnas: IColumnas<IConfigMarker>[] = [
      // Global: es un dato (aplica a todos los clientes o no)
      {
        header: {
          label: 'Global',
        },
        row: {
          parse: (dato) => (dato.global ? 'Sí' : 'No'),
        },
      },
      // Alcance
      {
        header: {
          label: 'Alcance',
          sortable: true,
          sort: 'scope',
        },
        row: {
          parse: (dato) => (dato.scope ? this.alcance(dato) : undefined),
          noData: 'Sin alcance',
        },
      },
      // Referencia (nombre según el alcance)
      {
        header: {
          label: 'Referencia',
        },
        row: {
          parse: (dato) => this.referencia(dato),
          noData: 'Sin referencia',
        },
      },
      // Cantidad de markers
      {
        header: {
          label: 'Markers',
        },
        row: {
          parse: (dato) => dato.vistas?.length,
          noData: 'Sin markers',
        },
      },
    ];
    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      columnas.push({
        header: {
          label: 'Cliente',
        },
        row: {
          html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
          tooltip: (dato) =>
            this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          noData: 'Sin cliente',
        },
      });
    }
    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Configuraciones - Editar iconos vehículos',
              ),
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Configuraciones - Eliminar iconos vehículos',
              ),
          },
        ],
      },
    });

    this.columnas = columnas;
  }
  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestroCliente);
    }
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.codigosEventos$?.unsubscribe();
  }
}
